"use strict";

var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEmojiDropdownMenuState = useEmojiDropdownMenuState;
var _plateEmoji = require("@udecode/plate-emoji");
var _cn = require("@udecode/cn");
var _useEmojiPicker = require("./useEmojiPicker");
/* copied from https://github.com/udecode/plate/blob/v36/packages/emoji/src/...
 * we can try to remove it after upgrading react and PlateJs
 */

function useEmojiDropdownMenuState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$closeOnSelect = _ref.closeOnSelect,
    closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? _plateEmoji.EmojiSettings : _ref$settings;
  var _ref2 = (0, _cn.useStableMemo)(function () {
      var frequentEmojiStorage = new _plateEmoji.FrequentEmojiStorage({
        limit: settings.showFrequent.limit
      });

      // eslint-disable-next-line @typescript-eslint/no-shadow
      var emojiLibrary = _plateEmoji.EmojiFloatingLibrary.getInstance(settings, frequentEmojiStorage);

      // eslint-disable-next-line @typescript-eslint/no-shadow
      var indexSearch = _plateEmoji.EmojiFloatingIndexSearch.getInstance(emojiLibrary);
      return [emojiLibrary, indexSearch];
    }, [settings]),
    _ref3 = _slicedToArray(_ref2, 2),
    emojiLibrary = _ref3[0],
    indexSearch = _ref3[1];
  var _ref4 = (0, _useEmojiPicker.useEmojiPicker)({
      closeOnSelect: closeOnSelect,
      emojiLibrary: emojiLibrary,
      indexSearch: indexSearch
    }),
    isOpen = _ref4.isOpen,
    setIsOpen = _ref4.setIsOpen,
    emojiPickerState = _objectWithoutProperties(_ref4, ["isOpen", "setIsOpen"]);
  return {
    emojiPickerState: emojiPickerState,
    isOpen: isOpen,
    setIsOpen: setIsOpen
  };
}